import React from 'react';

import { FieldArray } from 'react-final-form-arrays';

import AttributeMapperFieldView from './AttributeMapperField.view';

const AttributeMapperField = (props: {
  validate: () => void;
  options: any;
}) => {
  return (
    <FieldArray name='mapping' validate={props.validate}>
      {({ fields }) => (
        <AttributeMapperFieldView fields={fields} options={props.options} />
      )}
    </FieldArray>
  );
};

export default AttributeMapperField;
